import React from 'react';
import PropTypes from 'prop-types';
import {
    StyledH3,
    StyledSubtitle
} from '../../../../../Title/styles/Title.styled';
import { StyledReasonsCard } from '../../style/ReasonsSection.styled';

export const ReasonCard = ({ title, subtitle, specificCss }) => {
    return (
        <StyledReasonsCard $specificCss={specificCss}>
            <StyledH3>{title}</StyledH3>
            <StyledSubtitle>{subtitle}</StyledSubtitle>
        </StyledReasonsCard>
    );
};

ReasonCard.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    specificCss: PropTypes.string
};
